export default{
    methods: {

        setLoginInfoMixin: function() {
            let authInfo = {};
            let loggedUserInfo = this.$store.getters["authcUser/getLoggedUserInfo"];
            if (loggedUserInfo == null) {
                return;
            }
            authInfo['username'] = loggedUserInfo.name;
            authInfo['companyname'] = loggedUserInfo.companyname;
            return authInfo;
        },
        setMainteLoginInfoMixin: function() {
            let authInfo = {};
            let loggedUserInfo = this.$store.getters["authcUser/getLoggedUserInfo"];
            if (loggedUserInfo == null) {
                return;
            }
            authInfo['username'] = loggedUserInfo.name;
            authInfo['deptname'] = loggedUserInfo.deptname;
            return authInfo;
        }

    }
}